import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useTheme } from "../../hooks";
import { cn } from "../../helper/utilityHelper";
import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
export default function DatePickerWithRange({
  setFromTo = { from: undefined, to: undefined },
  className,
  onDateChanged = () => {},
}) {
  // const [date, setDate] = React.useState(null);
  const [date, setDate] = React.useState(setFromTo);
  const { theme: mode } = useTheme();

  // React.useEffect(() => {
  //   setDate(setFromTo);
  // }, [setFromTo]);

  debugger;
  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            color={mode === "dark" && "secondary"}
            className={cn(" font-normal", {
              " bg-white text-default-600": mode !== "dark",
            })}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from && date?.to ? (
              <>
                {format(date.from, "LLL dd, y")} -{" "}
                {format(date.to, "LLL dd, y")}
              </>
            ) : date?.from ? (
              <>Start - {format(date.from, "LLL dd, y")}</>
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={(val) => {
              setDate(val);
              onDateChanged(val);
            }}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
